import type { SpreadLayoutTemplate } from './layout-types';

export const BALANCED_3_LAYOUT: SpreadLayoutTemplate = {
  id: 'balanced-3',
  family: 'triad',
  cards: 3,
  description: 'Triade equilibrata per assi mente-corpo-spirito e letture a pari peso simbolico.',
  supports_focus_overlay: false,
  variants: [
    {
      id: 'portrait',
      points: [
        { x: 50, y: 24, z: 1 },
        { x: 24, y: 72, z: 1 },
        { x: 76, y: 72, z: 1 },
      ],
    },
    {
      id: 'compact',
      points: [
        { x: 50, y: 28, z: 1 },
        { x: 28, y: 68, z: 1 },
        { x: 72, y: 68, z: 1 },
      ],
    },
    {
      id: 'wide',
      points: [
        { x: 50, y: 26, z: 1 },
        { x: 32, y: 68, z: 1 },
        { x: 68, y: 68, z: 1 },
      ],
    },
  ],
};
